import type { ReactNode } from "react";

interface BadgeProps {
  variant?: "red" | "green" | "yellow" | "blue" | "gray";
  size?: "sm" | "md";
  children: ReactNode;
  className?: string;
}

export function Badge({
  variant = "gray",
  size = "md",
  children,
  className = "",
}: BadgeProps) {
  const variants = {
    red: "bg-red-100 text-red-800",
    green: "bg-green-100 text-green-800",
    yellow: "bg-yellow-100 text-yellow-800",
    blue: "bg-blue-100 text-blue-800",
    gray: "bg-gray-100 text-gray-800",
  };

  const sizes = {
    sm: "px-2 py-0.5 text-xs",
    md: "px-3 py-1 text-sm",
  };

  return (
    <span
      className={`${variants[variant]} ${sizes[size]} rounded-full whitespace-nowrap inline-block ${className}`}
    >
      {children}
    </span>
  );
}
